import * as Sentry from '@sentry/react'
import { SENTRY_ERROR_CAPTURE_STRING } from './sentry-messages'

export const captureError = (message: string, extra: any) => {
  Sentry.captureMessage(message + SENTRY_ERROR_CAPTURE_STRING, {
    level: 'error',
    extra,
  })
}
